// PlanStaffingHoverMenu.jsx
import React from 'react';
import { RiPencilFill } from "react-icons/ri";
import { FiUsers } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useShiftHoverMenuPosition } from "hooks/useShiftHoverMenuPosition";

const PlanStaffingHoverMenu = ({ itemStaffing, row, index, onEdit, onBringEmployees, onMouseEnter, onMouseLeave }) => {
	const { t } = useTranslation();
	const { containerRef, positionStyle } = useShiftHoverMenuPosition();

	return (
		<div
			ref={containerRef}
			className="shift-hover-menu-container shift-hover-menu-container--fixed shift-hover-menu-container--staffing"
			style={positionStyle}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<div className="shift-hover-menu">
				{typeof onBringEmployees === "function" && (
					<button
						className="btn-hover-action btn-add"
						onClick={(e) => {
							e.stopPropagation();
							onBringEmployees(itemStaffing, row, index);
						}}
						title={t("plan.temporaryEmployees.open")}
					>
						<FiUsers />
					</button>
				)}
				{typeof onEdit === "function" && (
					<button
						className="btn-hover-action btn-edit"
						onClick={(e) => {
							e.stopPropagation();
							onEdit(itemStaffing, row, index);
						}}
						title="Editar necesidad"
					>
						<RiPencilFill />
					</button>
				)}
			</div>
		</div>
	);
};

export default PlanStaffingHoverMenu;

